:host {
  display: block;
}

@keyframes buttonPush {
  50% {
    transform: scale(0.95);
  }
}

.animation-push:active {
  animation: buttonPush 0.25s ease-in-out 1;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.spinner {
  display: grid;
  width: 1.5em;
  height: 1.5em;
  -webkit-mask: conic-gradient(from 16deg, rgb(0 0 0 / 0), black);
  mask: conic-gradient(from 16deg, rgb(0 0 0 / 0), black);
  animation: spin 1s steps(8) infinite;
  aspect-ratio: 1;

  --gradient: linear-gradient(currentColor 0 0) 50%;
  background:
    var(--gradient) / 34% 7% space no-repeat,
    var(--gradient) / 7% 34% no-repeat space;

  &:before {
    background:
      var(--gradient) / 34% 7% space no-repeat,
      var(--gradient) / 7% 34% no-repeat space;
    content: '';
    transform: rotate(45deg);
  }
}

.ico-button-animated--primary {
  background-color: var(--clrs-bg-button-primary);
  border-color: var(--clrs-border-button-primary);
  color: var(--clrs-text-button-primary);
  font-weight: var(--font-weight-button-primary);
}

.ico-button-animated--secondary {
  background-color: var(--clrs-bg-button-secondary);
  border-color: var(--clrs-border-button-secondary);
  color: var(--clrs-text-button-secondary);
  font-weight: var(--font-weight-button-secondary);
}

.ico-button-animated--tertiary {
  background-color: var(--clrs-bg-button-tertiary);
  border-color: var(--clrs-border-button-tertiary);
  color: var(--clrs-text-button-tertiary);
  font-weight: var(--font-weight-button-tertiary);
}

.ico-button-animated--start-action {
  background-color: var(--clrs-bg-button-start-action);
  border-color: var(--clrs-border-button-start-action);
  color: var(--clrs-text-button-start-action);
  font-weight: var(--font-weight-button-start-action);
  border-style: var(--border-style-button-start-action);
}

.btn-animated-text-custom-by-theme {
  text-transform: var(--text-transform-by-theme, none);
  font-weight: var(--font-weight-by-theme, 700);
  font-family: var(--font-family-by-theme);
}